import React, { useEffect, useState } from 'react';
import { getWithdrawReason } from '../../api/login';
import '../../css/Member.css';

export default function WithdrawalTwo({ setText, setSelectReason, selectReason, detailReason, setDetailReason }: any) {
  const [item, setItem] = useState<any>([]);

  useEffect(() => {
    getWithdrawReason().then((res) => {
      setItem(res.data);
    });
  }, []);

  // body 스크롤 제어
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <>
      <div className="withdrawal_wrap step2">
        <h3>
          탈퇴 하시려는 이유를
          <br />
          선택해 주세요
        </h3>
        <div className="radio_item_wrap">
          {item.map((el: string, index: number) => {
            return (
              <ReasonItem
                el={el}
                setSelectReason={setSelectReason}
                selectReason={selectReason}
                key={`${index}1`}
              ></ReasonItem>
            );
          })}

          {selectReason === '기타' ? (
            <div className="textarea_box">
              <p>상세 사유 입력</p>
              <textarea
                placeholder="탈퇴 상세 사유를 작성해주세요."
                onChange={(e) => {
                  setDetailReason(e.target.value);
                }}
              ></textarea>
            </div>
          ) : null}
        </div>
        {/* - 탈퇴 사유 - */}
        <div className="btn_box">
          <button
            onClick={(e) => {
              if (!selectReason) {
                alert('탈퇴 사유를 선택해주세요');
                return;
              }
              if (selectReason === '기타' && detailReason === '') {
                alert('상세 사유를 입력해주세요');
                return;
              }

              e.preventDefault();
              setText('three');
            }}
          >
            다음으로
          </button>
        </div>
      </div>
    </>
  );
}

function ReasonItem({ el, setSelectReason, selectReason }: any) {
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    if (selectReason === el) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [selectReason]);
  return (
    <>
      <div
        className="radio_item"
        onClick={() => {
          setSelectReason(el);
        }}
      >
        {checked ? (
          <>
            <img src="/images/icon_radio_true.png" alt="radio_button" />
            <p style={{ color: 'var(--colBlack)' }}>{el}</p>
          </>
        ) : (
          <>
            <img src="/images/icon_radio_false.png" alt="radio_button" />
            <p>{el}</p>
          </>
        )}
      </div>
    </>
  );
}
